export default "__VITE_ASSET__DzfX5L6s__"